// Generated by CoffeeScript 2.7.0
var Location;

import Base from './base.js';

export default Location = (function() {
  class Location extends Base {};

  Location.setAttributes(['longitude', 'latitude', 'max_distance']);

  return Location;

}).call(this);
